<template>
  <div class="container">
    <div class="h2 text-center mt-2">
      {{ titleString }}
    </div>
    <div
      class="objects-last-seen"
    >
      <!-- params on key to keep them unique -->
      <objects-preview
        v-for="(object, index) in searchObjectsTeaserStore"
        :key="`previewElement_${object.objectNumber}_${hashedSearchURL}`"
        :class="index === 4 ? 'd-none d-lg-block' : ''"
        :object-data="object"
        :location-of-object="getObjectLocationString(object)"
      />
    </div>
    <router-link-simple
      class="btn btn-primary btn-block btn-sm  col-md-3 mx-auto"
      :to="searchString"
      data-ident="customObjectTeaserSearch"
      @click.native="scrollToTop"
    >
      Alle Unterkünfte
    </router-link-simple>
  </div>
</template>

<script>
import ObjectsPreview from 'components/ObjectsPreview.vue';
import { mapActions } from 'vuex';
import RouterLinkSimple from 'components/RouterLinkSimple.vue';
import { sha256 } from 'js-sha256';

export default {
  name: 'CustomObjectTeaser',

  components: {
    ObjectsPreview,
    RouterLinkSimple,
  },
  props: {
    titleString: {
      type: String,
      default: '',
    },
    searchString: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      objects: [],
    };
  },
  computed: {
    hashedSearchURL() {
      return sha256(this.searchString);
    },
    searchObjectsTeaserStore() {
      return this.$store.getters.getSearchObjectsTeaser(this.hashedSearchURL);
    },
  },
  serverPrefetch() {
    return this.request();
  },
  mounted() {
    // only do search if needed
    if (!this.searchObjectsTeaserStore) {
      this.request();
    }
  },
  methods: {
    ...mapActions({ searchObjectsTeaser: 'SEARCH_OBJECTS_TEASER' }),
    request() {
      this.objects = [];
      const queryParams = {};
      // split url up to get GET params, then map them in to key value pairs
      // removes start of copied query e.g. /search/?
      const searchForPageCall = /.*\?/;
      // removes anchor and text behind anchor e.g, #searchResult then splits elements on "&"
      const searchForAnchor = /#.*/;
      let urlElements = this.searchString.replace(searchForPageCall, '');
      urlElements = urlElements.replace(searchForAnchor, '').split('&');
      // split again on = to separate the key from the value
      const splittedParamsArr = urlElements.map((content) => content.split('='));
      // mutate splittedParams array in to object
      splittedParamsArr.forEach((paramPair) => {
        // destructure array
        const [key, value] = paramPair;
        // add to object
        queryParams[key] = value;
      });
      return this.searchObjectsTeaser(
        { queryParams, searchURL: this.searchString },
      );
    },
    getObjectLocationString(object) {
      return (object.seoLinkLocationName || object.seoLinkRegionName) || '';
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

};
</script>
<style lang ="scss" src="@/scss/LastSeenObjects.scss" clientextend></style>
<style lang="scss" src="scss/LastSeenObjectsScoped.scss"></style>
<style lang="scss" scoped>
/deep/ .objects-last-seen {
  @media #{$media_sm_max} {
    grid-template-columns: repeat(auto-fit, minmax(11em, 0.5fr));
  }
  @media #{$media_xs_max} {
    grid-template-columns: repeat(auto-fit, minmax(11em, 1.5fr));
  }
}
input{
  width: 80%;
}

</style>
